import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import{ LoopBackAuth, causasService} from '../../services/api-rest.service';
import{MessageService} from '../../services/message.service';

@Component({
  selector: 'modal-causas-calificacion',
  templateUrl: './modal-causas-calificacion.component.html',
  providers:[LoopBackAuth, causasService, MessageService]
})
export class ModalCausasCalificacionComponent implements OnInit {
  @Input()  idCalificacion
  @Input() preview
  @Input() activarNovedad

  causas: any
  sugerencia: any
  acciones:any
  seleccion: any
  constructor(
    public activeModal: NgbActiveModal,
    public causasService:causasService
  ) { }

  ngOnInit() {
    this.sugerencia ={
      id:null,
      sugerencia: null,
      acciones: null
    }
    this.search()
  }


  search(){
  
    this.causasService.searchCalificacion(this.idCalificacion).subscribe(
      lista =>{
        if(lista){
          console.log("causa -->", lista)
          this.causas = lista 
          if(this.activarNovedad) this.causas[0].aca_calificacion_causa_id=true
          this.sugerencia.id = lista[0].aca_calificacion_sugerencia_id
          this.sugerencia.sugerencia =  lista[0].aca_calificacion_sugerencia_sugerencia
          this.sugerencia.acciones = lista[0].aca_calificacion_sugerencia_accion
        }
        
        
      }
    )
  }

  guardar(){
      if(this.activarNovedad && (this.sugerencia.acciones == "" || this.sugerencia.acciones == null)) {
        this.causas[0].aca_calificacion_causa_id=false
      }
      this.changeCheck()
      this.causasService.createUpdate(this.idCalificacion,this.seleccion.toString(), this.sugerencia).subscribe(
        item =>{
          if(item){
            this.activeModal.close(this.seleccion.length)
          }
        }
      )
  }

  changeCheck(){
    let orden =[]
    for(let item of this.causas){
      if(item.aca_calificacion_causa_id > 0)
        orden.push(item.aca_causa_calificacion_id)
    }
    this.seleccion = orden
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-causas-calificacion/modal-causas-calificacion.component.ts